import script from "./OrdemCompraCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./OrdemCompraCadastro.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__